import { rightBarActions } from '../slices/rightBarSlice'

export const showRightBar = (payload: { rightBarItem: any, disableHide: boolean }) => {
    return rightBarActions.show(payload)
}
export const showScheduleBar = (payload: { rightBarItem: any }) => {
    return rightBarActions.scheduleBar(payload)
}
export const showActionsBar = (payload: { rightBarItem: any }) => {
    return rightBarActions.actionsBar(payload)
}
export const fullScreenRightBar = () => {
    return rightBarActions.fullScreen()
}
export const collapseRightBar = () => {
    return rightBarActions.collapse()
}
export const hideRightBar = () => {
    return rightBarActions.hide()
}
export const rightBarButtonsShake = (isAnimated: boolean) => {
    return rightBarActions.setShakeAnimation(isAnimated)
}